import { render } from "./params.vue?vue&type=template&id=4c0293ea"
import script from "./params.vue?vue&type=script&lang=js"
export * from "./params.vue?vue&type=script&lang=js"

import exportComponent from "F:\\fmvic\\Escritorio\\ProyectosDef\\GAB360\\Apps\\Certivin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__